import type { RootState } from 'store'

export const getPage = (state: RootState) =>
  state?.capturedWines?.pageInfo?.page
export const getItems = (state: RootState) => state?.capturedWines?.items || []
export const getSelectedItems = (state: RootState) =>
  state?.capturedWines?.selectedItems || []
export const getPageInfo = (state: RootState) =>
  state?.capturedWines?.pageInfo ?? {}
export const getUpdatingItems = (state: RootState) =>
  state?.capturedWines?.updatingItems ?? []
